import {
  initialState,
  Actions,
  State,
  GET_ALL_ELEMENTS,
  GET_ALL_ELEMENTS_SUCCESS,
  GET_ALL_ELEMENTS_ERROR,
  RESET_GET_ALL_ELEMENTS,
  UPDATE_ALL_CURRENT_ELEMENTS
} from '../../types/element/get-all'

const reducers = (state = initialState, action: Actions<any>): State<any> => {
  switch (action.type) {
    case GET_ALL_ELEMENTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_ELEMENTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_ELEMENTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case UPDATE_ALL_CURRENT_ELEMENTS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      }
    case RESET_GET_ALL_ELEMENTS:
      return initialState
    default:
      return state
  }
}

export default reducers
